
import React from 'react';

const Footer = () => {
  return (
    <footer className="py-12 px-6 bg-dark text-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 pb-8 border-b border-gray-700">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-primary rounded-md flex items-center justify-center">
                <span className="text-white font-bold text-xl">AI</span>
              </div>
              <span className="font-bold text-xl">KI-Wissensplattform</span>
            </div>
            <p className="text-gray-400 max-w-md">
              Nutze KI-Technologie wie die Großen – auf DEINER eigenen, 
              sicheren Infrastruktur in Deutschland.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h4 className="font-semibold mb-4">Kontakt</h4>
              <address className="text-gray-400 not-italic">
                <p>enpit GmbH & Co. KG</p>
                <p>Marienplatz 11a</p>
                <p>33098 Paderborn</p>
              </address>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Navigation</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#features" className="text-gray-400 hover:text-white transition-colors">Features</a>
                </li>
                <li>
                  <a href="#benefits" className="text-gray-400 hover:text-white transition-colors">Vorteile</a>
                </li>                
                <li>
                  <a href="#contact" className="text-gray-400 hover:text-white transition-colors">Kontakt</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col md:flex-row md:justify-between items-center gap-4 mt-8">
          <p className="text-gray-400 text-sm">
            © 2024 enpit GmbH & Co. KG / ailio GmbH. Alle Rechte vorbehalten.
          </p>
          
          <div className="flex gap-6">
            <a href="https://enpit.de/impressum" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors">
              Impressum
            </a>
            <a href="https://enpit.de/datenschutz" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors">
              Datenschutz
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
// <li>                  <a href="#testimonials" className="text-gray-400 hover:text-white transition-colors">Referenzen</a>                </li>
export default Footer;
